import { compose, flattenProp } from 'recompose';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { addProps, addIntlProps } from 'utils/recompose';
import messages from './messages';
import styles from './styles.module.scss';
import formatCurrency from 'utils/formatCurrency';
import {
  currentSelectedQuantity,
  inCartQuantity,
  model,
  modelRemainingQuota,
  modelSubmittedTotalWorkingStateCalculated,
  modelWorkingStateDenormalized,
} from 'reducers/models/selectors';
import {
  modelTemplatesWorkingStateLoading,
  seriesAllocationLoading,
} from 'reducers/loading/selectors';
import { mini, addDisclaimer } from 'reducers/dashboard/selectors';
import combineSelectors from 'utils/combineSelectors';
import { seriesDetailPageLoaded } from 'reducers/loading/selectors';
import { modelDescriptionLimit } from 'constants/values';

const basePriceFormatted = formatCurrency({
  priceProp: 'basePrice',
  currencyProp: 'currency',
});

const mapStateToProps = combineSelectors({
  addDisclaimer,
  currentSelectedQuantity,
  inCartQuantity,
  mini,
  model,
  modelRemainingQuota,
  modelSubmittedTotalWorkingStateCalculated,
  modelTemplatesWorkingStateLoading,
  modelWorkingStateDenormalized,
  seriesAllocationLoading,
  seriesDetailPageLoaded,
});

export const submitted = ({ modelSubmittedTotalWorkingStateCalculated }) =>
  modelSubmittedTotalWorkingStateCalculated;

// TODO: Once IPA data inconsistency is resolved, then we can use remainingQuota
// Until then, we calculate remainingQuota
export const calculatedRemainingQuota = ({
  quota,
  modelSubmittedTotalWorkingStateCalculated,
  inCartQuantity,
}) => {
  let calculatedRemaining =
    quota - modelSubmittedTotalWorkingStateCalculated - inCartQuantity;
  return calculatedRemaining >= 0 ? calculatedRemaining : 0;
};

export const inactiveStylingCollapsed = value =>
  value === 0 ? styles.inactiveStatCollapse : styles.activeStatCollapse;

export const modelTitleStyle = ({ description }) => {
  return description && description.length >= modelDescriptionLimit
    ? styles.smallModelTitle
    : styles.modelTitle;
};

const styleStat = ({
  calculatedRemainingQuota,
  inCartQuantity,
  modelTitleStyle,
  submitted,
}) => ({
  remaining: inactiveStylingCollapsed(calculatedRemainingQuota),
  inCart: inactiveStylingCollapsed(inCartQuantity),
  submitted: inactiveStylingCollapsed(submitted),
  modelTitle: modelTitleStyle,
});

export default compose(
  connect(mapStateToProps),
  flattenProp('model'),
  injectIntl,
  addIntlProps({
    messages,
    propNames: [
      'remainingQuotaLabel',
      'inCartLabel',
      'submittedLabel',
      'basePriceLabel',
      'currency',
    ],
  }),
  addProps({
    calculatedRemainingQuota,
    modelTitleStyle,
  }),
  addProps({
    submitted,
    styleStat,
    basePriceFormatted,
  }),
);
